import styled from 'styled-components/macro';
export const ScInternalError = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  p {
    font-size: 32px;
    font-weight: bold;
  }
  a {
    color: #b69deb;
  }
`;
